// extracted by mini-css-extract-plugin
export var borderRadius = "_90-4";
export var large = "_90-3";
export var logoContainer = "_90-0";
export var nameLogo = "_90-2";
export var small = "_90-1";